// extracted by mini-css-extract-plugin
export default {"ward_nav":"Navigation_ward_nav__ujnba","active":"Navigation_active__9+16u"};